import {map} from 'rxjs/operators';

import {ActivatedRoute, Router} from '@angular/router';
import {ApiServiceService} from '../api-service.service';
import {Component, OnInit, ViewChild} from '@angular/core';
import {Keys, StorageService} from '../service/storage.service';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {BreadcrumbLabel, HasBreadcrumb} from '../borrow/borrower-dashboard/breadcrumbs/breadcrumb';
import {HttpClient} from '@angular/common/http';

@Component({
    selector: 'app-passbook',
    templateUrl: './passbook.component.html',
    styleUrls: ['./passbook.component.css'],
    providers: [ApiServiceService]
})

export class PassbookComponent implements OnInit, HasBreadcrumb {

    private loanId: string;
    shortLoanId: string;
    result2: any;
    data: any = [];
    noPassbookdata = false;
    loan_sanction_status: any;
    dashLink: any;
    amountRepaid = 0;
    amountDue = 0;
    fractionSize: any;
    finzyDomain = true;
    otherDomain = false;
    isReferralSchemeEnabled: boolean;

    displayedColumns: any = ['timestamp', 'type', 'amount', '-'];
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    dataSource: any;

    constructor(private http: HttpClient, private router: Router, private ref: ApiServiceService, private storageService: StorageService,
                private route: ActivatedRoute) {
    }

    ngOnInit() {
        this.isReferralSchemeEnabled = ApiServiceService.isReferralSchemeEnabled();

        this.loanId = this.route.snapshot.params.loanId;

        if (this.storageService.getItem(Keys.DOMAIN) === 'tripfactory') {
            this.finzyDomain = false;
            this.otherDomain = true;
        } else {
            this.finzyDomain = true;
            this.otherDomain = false;
        }

        this.result2 = this.http.post<any>(this.ref.baseURL() + 'getBorrowerPassbook',
            {
                profile_id: this.storageService.getItem(Keys.PROFILE_ID),
                loan_id: this.loanId,
                token: this.storageService.getItem(Keys.TOKEN)
            }).subscribe((result2) => {
            this.result2 = result2;
            if (this.result2.status_code === 200 && this.result2.status === 'success') {
                if (this.result2.passbookDetails.borrower_passbook.length === 0) {
                    this.noPassbookdata = true;
                } else {
                    this.noPassbookdata = false;
                    this.data = this.result2.passbookDetails.borrower_passbook[0].details.reverse();
                    this.dataSource = new MatTableDataSource(this.data);
                    this.dataSource.sort = this.sort;
                    this.dataSource.paginator = this.paginator;

                    this.amountRepaid = this.result2.repaidAmt;
                    this.amountDue = this.result2.dueAmt;
                }
            }
        });

        this.http.post<any>(this.ref.baseURL() + 'getLoanInfoDetails',
            {
                loan_id: this.loanId,
                profile_id: this.storageService.getItem(Keys.PROFILE_ID),
                token: this.storageService.getItem(Keys.TOKEN)
            }).subscribe((result2) => {
                if (result2.status === 'success') {
                    this.shortLoanId = result2.loan_info.generated_loan_id;
                    this.loan_sanction_status = result2.loan_info.loan_sanction_status;

                    if (this.loan_sanction_status === 'loan_disbursed' || this.loan_sanction_status === 'document_hardcopy_recieved') {
                        this.dashLink = ['/borrowerdashboard'];
                    } else if (this.loan_sanction_status === 'ready_for_kyc' || this.loan_sanction_status === 'kyc_in_progress' ||
                        this.loan_sanction_status === 'ready_for_pcd' || this.loan_sanction_status === 'pcd_in_progress' || this.loan_sanction_status === 'ready_for_dcd' ||
                        this.loan_sanction_status === 'dcd_in_progress' || this.loan_sanction_status === 'sanctioned' || this.loan_sanction_status === 'rejected') {
                        this.dashLink = ['/loansanction'];
                    } else if (this.loan_sanction_status === 'queued_to_be_fulfilled' || this.loan_sanction_status === 'accepted' || this.loan_sanction_status === 'bank_details_filled' || this.loan_sanction_status === 'document_verified' ||
                        this.loan_sanction_status === 'ready_for_disbursal' || this.loan_sanction_status === 'loan_disbursed_initiated' || this.loan_sanction_status === 'loan_fulfilled') {
                        this.dashLink = ['/loanprogress'];
                    }

                }
            });

    }

    async breadcrumb(): Promise<BreadcrumbLabel> {
        return BreadcrumbLabel.Passbook;
    }
}
